module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAABHNCSVQICAgIfAhkiAAAAERJREFUOE9jZKAyYMRlXupDl//IcrPl9+BUi6xu8BiIywdku3AEGEgodcFSAdFhSLKB6IFMyAB0eQwXjhpIahAy0CwMAaNpSBA/fTUrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/automode/icon_histogram.png
// module id = 108
// module chunks = 7